import { parse } from "cookie";
import logoutSession from "./logout.js";

/**
 * Makes an API request to refresh the session token cookie, if it exists.
 * @param {Object}   [options] - Optional configuration parameters.
 * @param {function} [options.onSuccess] - An optional success callback.
 * @param {function} [options.onError] - An optional error callback.
 * @return {Function} Returns a promise
 */
const refreshSession = async (options = {}) => {
  const url = "/api/auth/sessions/refresh";
  let cookies = parse(window.document.cookie);
  const headers = new Headers({
    Accept: `application/vnd.qpp.cms.gov.v2+json`,
    "Content-Type": "application/json",
    Authorization: `Bearer ${cookies.qpp_auth_token}`,
  });
  const fetchOptions = {
    method: "POST",
    headers,
  };

  const onSuccess = () => {
    if (typeof options.onSuccess === "function") {
      options.onSuccess();
    }
  };

  const onError = () => {
    if (typeof options.onError === "function") {
      options.onError();
    }

    return logoutSession(window);  
  };

  try {
    const response = await fetch(url, fetchOptions);
    if (response.ok) {
      return onSuccess();
    }
    throw new Error("Unable to refresh session");
  } catch {
    onError();
  }
};

export default refreshSession;
